<template>
  <div class="tutor-page">
    <div class="top-menu">
      <div class="top">人工智能与机器视觉实验室</div>
      <div class="blank"></div>
      <div class="menu">
        <div class="menu-detail" @click="jumpToHome">首页</div>
        <div class="menu-detail" @click="jumpToTutor">导师风采</div>
        <div class="menu-detail" @click="jumpToTeam">科研团队</div>
        <div class="menu-detail" @click="jumpToPaper">论文成果</div>
        <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
        <div class="menu-detail" @click="jumpToDownload">文件下载</div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contributions </div>
      </div>
    </div>
    <div class="blank"></div>
    <div class="page-content">
      <div class="informations">
        <div class="tutor-information">
          <div class="tutor-name">雷涛</div>
          <div class="tutor-information-content">
            <div class="tutor-information-list">
              <span class="tutor-information-word">陕西科技大学人工智能学院</span>
              <span class="tutor-information-word">博士生导师 IEEE高级会员</span>
            </div>
            <div class="tutor-direction-list">
              <span class="tutor-direction-word">博士方向：轻工信息与人工智能</span>
              <span class="tutor-direction-word">硕士方向：人工智能技术 电子信息 软件工程</span>
            </div>

          </div>
          <div class="contact">
            <span class="contact-word">电子邮箱：leitaoly@163.com</span>
            <span class="contact-word">办公地点：实验楼2B-519</span>
          </div>
        </div>

      </div>

      <div class="blank"></div>
      <div class="introduction">
        <span class="introduction-title">导师简介</span>
        <span class="introduction-word">
          <i class="iconfont icon-yuandianzhong"></i>
          陕西科技大学教授、博士生导师、校学术委员会委员、电子信息与人工智能学院副院长，IEEE高级会员；担任中国图象图形学学会视觉传感专委会委员，中国体视学学会图像分析分会委员，陕西省图象图形学学会理事，陕西省公安厅科技信息化委员会专家，第16届ICNC-FSKD国际会议大会共同主席，CSIG图像图形中国行执行主席，人工智能顶级会议AAAI2020、IJCAI2020、IJCAI2019程序委员会委员，《应用科技》编委，Remote
          Sensing期刊客座编辑；2011年毕业于西北工业大学信息与通信工程专业，获工学博士学位，2012-2014年在西北工业大学电子科学与技术博士后流动站从事计算机视觉领域的研究工作（优秀出站）、2016-2019年在西北工业大学计算机科学与技术博士后流动站从事人工智能领域的研究工作（优秀出站）；2014-2019年先后4次赴澳大利亚悉尼科技大学、英国布鲁内尔大学进行访学研究（合作导师分别为澳大利亚科学院院士DachengTao教授、英国皇家工程院院士Asoke
          K. Nandi教授）；主要研究方向为计算机视觉、机器学习等；目前已在国内外权威刊物及会议IEEE TIP、IEEE TFS、IEEE
          TGRS、IEEETGRSL、ICASSP、ICIP等发表论文80余篇，其中1篇论文入选ESI高被引论文，3篇论文入选IEEE
          TFS最受关注的论文（其中2篇在2019年8月和10月分别排名第1），1篇论文入选IEEE
          TIP最受关注的论文；主持国家自然科学基金4项，中国博士后科学基金特别资助1项，中国博士后基金面上项目2项，陕西省博士后基金项目2项；获省高等学校科研优秀成果奖3项，其中一等奖2项，三等奖1项，2018年获IEEE第13届人脸及姿态识别国际会议（FG2018，CCF推荐会议）-手势识别项目全球挑战赛亚军。</span>
      </div>
    </div>
         <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
  </div>
</template>

<script>
  export default {
    data() {
     
    },
    methods: {
      jumpToHome() {
        this.$router.push({
          name: "home",
        });
      },
      jumpToTutor() {
        this.$router.push({
          name: "tutor",
        });
      },
      jumpToTeam() {
        this.$router.push({
          name: "team",
        });
      },
      jumpToPaper() {
        this.$router.push({
            name: "paper",
        });
      },
      jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
      jumpToDownload() {
        this.$router.push({
            name: "download",
        });
      },
      jumpToInnovation() {
        this.$router.push({
            name: "innovation",
        });
      },
      jumpToService() {
        this.$router.push({
            name: "service",
        });
      },
      jumpToInfluence_Contribution() {
        this.$router.push({
          name: "influence_contribution",
        });
      },
    },
  };
</script>

<style scoped>
  .tutor-page {
    width: 100%;
    height: 100%;
    background-color: #fffef9;
    display: flex;
    flex-direction: column;
  }

  .top-menu {
    width: 100%;
  }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }

  .menu-detail:hover {
    background-color: #dfe8ed;
  }

  .page-content {
    width: 100%;
  }

  .informations {
    display: flex;
    flex-direction: row;
    height: 25vh;
    padding: 30px 0;
  }



  .tutor-information {
    padding-left: 100px;
    display: flex;
    flex-direction: column;
    
  }

  .tutor-name {
    font-size: 24px;
    padding: 30px 0;
  }

  .tutor-information-content {
    display: flex;
    flex-direction: row;
  }

  .tutor-information-list {
    display: flex;
    flex-direction: column;
  }

  .tutor-information-word {
    line-height: 3vw;
    font-size: 16px;

  }

  .tutor-direction-list {
    display: flex;
    flex-direction: column;
    padding-left: 200px;
    
  }

  .tutor-direction-word {
    line-height: 3vw;
    font-size: 16px;
  }

  .contact {
    padding: 0 0 0 0px;
  }

  .contact-title {
    padding-right: 10px;
  }

  .contact-word {
    line-height: 3vw;
    padding-right:176px;
    font-size: 16px;
  }

  .introduction {
    display: flex;
    flex-direction: column;
    padding: 0 100px;
    padding-top: 20px;
  }

  .introduction-title {
    /* padding:0px 100px; */
    line-height: 50px;
    font-size: 22px;
  }

  .introduction-word {
    line-height: 30px;
    padding-left: 20px;
    padding-bottom: 25px;
  }
  .icon-yuandianzhong {
        color: #8a9098;
    }
    .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
        width: 100%;
        position: fixed;
        bottom: 0;
    }
</style>